import React from 'react';
import './works.css';

const Works = () => (
    <section id="works">
        <h2 className="worksTitle">The Boys' Mentorship Programme</h2>
        <p className="worksDesc">Christian mentorship for boys aged 7–17, welcoming participants from different families and religious backgrounds.</p>
        <div className="programmeCards">
            <article className="programmeCard">
                <h3>Holiday mentorship</h3>
                <p>Structured holiday programmes give boys space to learn, reflect and develop self-discipline alongside their peers.</p>
            </article>
            <article className="programmeCard">
                <h3>Camps &amp; outdoor learning</h3>
                <p>Residential camps combine mentorship with outdoor activities, teamwork and survival skills.</p>
            </article>
            <article className="programmeCard">
                <h3>Growing through responsibility</h3>
                <p>The programme aims to prepare young men to contribute to their families and communities with respect and integrity.</p>
            </article>
        </div>
        <a className="workBtn" href="https://boysmentorship.africa/" target="_blank" rel="noopener noreferrer">Explore the programme</a>
    </section>
);

export default Works;
